// apps/web/src/layouts/components/SidebarCountBadge.tsx
//
// Pílula numérica da sidebar admin. Fonte única do visual dos badges: os badges
// nomeados (aprovações, fila do analista, chamados...) e o badge agregado do
// ancestral colapsado renderizam todos por aqui, mudando só rótulo e testid.

export type SidebarCountBadgeVariant = 'highlighted' | 'muted' | 'urgent';

export interface SidebarCountBadgeProps {
  /** Zero (ou negativo) não renderiza nada. */
  count: number;
  label: string;
  testId: string;
  variant?: SidebarCountBadgeVariant;
}

export function SidebarCountBadge({
  count,
  label,
  testId,
  variant = 'highlighted',
}: SidebarCountBadgeProps) {
  if (count <= 0) return null;

  const style =
    variant === 'urgent'
      ? 'bg-red-600 text-white'
      : variant === 'highlighted'
        ? 'bg-amber-500 text-white'
        : 'bg-amber-100 text-amber-800';

  return (
    <span
      data-testid={testId}
      title={label}
      aria-label={label}
      className={
        'inline-flex min-w-5 items-center justify-center rounded-full px-1.5 py-0.5 ' +
        'text-[10px] font-body font-semibold tabular-nums ' +
        style
      }
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}
